import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';


// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ReadingSession from './readingSession';

import {
  fetchCurrentReadingSessions,
  clearCurrentReadingSessions
} from '../../modules/reader';

export class ReadingSessionsFeed extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    const { idToken, currentBook } = this.props;
    const { readerId } = this.props.match.params;

    this.props.fetchCurrentReadingSessions(idToken, { bookId: currentBook._id, readerId: readerId })
  }

  componentWillUnmount() {
    this.props.clearCurrentReadingSessions();
  }

  render() {
    const { currentReadingSessions } = this.props;
    if (!currentReadingSessions || !Array.isArray(currentReadingSessions)) {
      return (
        <p role="status" aria-live="polite">Loading reading sessions…</p>
      );
    }
    return (
      <div className="br-reading-sessions" aria-label="Reading sessions">
        {
          currentReadingSessions.map((session, index) => {
            return (
              <ReadingSession key={session._id} session={session} startOpen={index === 0} />
            )
          })
        }
      </div>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
  currentReader: state.reader.currentReader,
  currentReadingSessions: state.reader.currentReadingSessions,
  readingSessionEventData: state.reader.readingSessionEventData
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCurrentReadingSessions,
  clearCurrentReadingSessions,
  changePage: (newPage) => push(newPage)
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ReadingSessionsFeed))
